"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNextUniqueId = getNextUniqueId;
var nextUniqueId = 0;

function getNextUniqueId() {
  return nextUniqueId++;
}


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/dist/cjs/utils/getNextUniqueId.js
// module id = 1244
// module chunks = 0